import React, { useContext} from "react";
import { connectToLocale } from '@insight/toolkit-react'
import { PDPContext } from '../context'
import { ENABLE_NIA } from '../constants'
import ProductBetterTogether from './ProductBetterTogether/ProductBetterTogether'
import ProductDetailsCompare from './ProductDetailCompare/ProductDetailCompare'
import ProductDetailsSpecifications from './ProductDetailsSpecifications/ProductDetailsSpecifications'
import ProductDetailTabs from './ProductDetailTab/ProductDetailTabs'
import { ProductGallery } from './ProductGallery'
import ProductPeopleBoughtTogether from './ProductPeopleBoughtTogether/ProductPeopleBoughtTogether'
import ProductNiaContainer from './ProductNiaContainer'

const PlacementsDetailPage = ({ context }) => {
  const {
    product = {},
  } = useContext(PDPContext)
  const featureFlags = window?.flags ?? {}
  const isNiaAvailable = Boolean(featureFlags[ENABLE_NIA])
  const isCCXProduct = product?.materialQualifier === 'CCX';

    return(
      <>
        <section className="o-grid o-grid--gutters">
          <div className="o-grid__item u-1/1 u-1/3@tablet">
            <ProductGallery />
            { isNiaAvailable && <ProductNiaContainer product={product} /> }
          </div>
          <div className="o-grid__item u-1/1 u-2/3@tablet">
            <ProductDetailsSpecifications
              isCCXProduct={isCCXProduct}
            />
          </div>
        </section>
        {!isCCXProduct && <ProductBetterTogether />}
        <ProductDetailTabs
          isCCXProduct={isCCXProduct}
        />
        <ProductDetailsCompare />
        <ProductPeopleBoughtTogether />
      </>
    )
}

export default connectToLocale(PlacementsDetailPage)